/**
 * Derive the Hermes API base URL from the current host — mirrors the monolith's
 * geoUrl('api.', ...) pattern and the (non-exported) helper inside
 * @react-components/auth. Used only to fetch a company's enabled login buttons.
 *
 * On localhost it falls back to the dev environment.
 */
export function resolveApiBase() {
    if (typeof window === 'undefined') {
        return 'https://api.dev.espmaestro.com';
    }
    var host = window.location.host;
    var normalizedHost = host.indexOf('localhost') === -1 ?
        host.replace(/^www\./, '') :
        'dev.espmaestro.com';
    return "https://api.".concat(normalizedHost);
}
